export default {
  init() {
    $(document).ready(function () {

      $('.mega-toggle-label').attr('aria-label','Toggle Mega Menu');
      // var header_height = $('header.banner').outerHeight();
      // $('body').css("padding-top", header_height);
      
      setTimeout(function () {
        // Select the filter sidebar element
        const $filterSidebar = $('.filter-sidebar');
  
        // Function to check classes and update aria-hidden attribute
        function updateAriaHidden() {
          if ($filterSidebar.hasClass('filter-open') && $filterSidebar.hasClass('filter-visible')) {
            $filterSidebar.show(500);
          } else {
            $filterSidebar.hide(500);
          }
        }
  
        // Call the function initially if needed
        updateAriaHidden();
      }, 1000);
  
      $('.toggle-filter .show-filters').click(function () {
        $('.filter-sidebar').show(1000);
      });
  
      $('.toggle-filter .hide-filters').click(function () {
        $('.filter-sidebar').hide(1000);
      });
    });

    // JavaScript to be fired on all pages
    $(window).on('load', function() {

      $('.hero-slider').slick({
        autoplay: true,
        autoplaySpeed: 7000,
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        arrows: false,
      });

      $.fn.randomize = function (selector) {
        var $elems = selector ? $(this).find(selector) : $(this).children(),
            $parents = $elems.parent();

        $parents.each(function () {
            $(this).children(selector).sort(function (childA, childB) {
                // * Prevent last slide from being reordered
                if($(childB).index() !== $(this).children(selector).length - 1) {
                    return Math.round(Math.random()) - 0.5;
                }
            }.bind(this)).detach().appendTo(this);
        });

        return this;
    };

    $('.split-slider').slick({
      autoplay: true,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      arrows: false,
    });

    $('.showroom-slider').slick({
      autoplay: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      arrows: false,
    });    

    $('.hero-slider-random').randomize().slick({
      autoplay: true,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      arrows: false,
    });

      $('.col-carousel').slick({
        autoplay: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        arrows: false,
      });

      $('.product-slider-col-1').slick({
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        speed: 1500,
        fade: true,
        arrows: false,
      });

      $('.product-slider-col-2').slick({
        infinite: true,
        speed: 1500,
        fade: true,
        arrows: false,
      });

      $('.product-slider-col-3').slick({
        infinite: true,
        speed: 1500,
        fade: true,
        arrows: false,
      });

      $('.product-slider-col-1').on('afterChange', function(){
        $('.product-slider-col-1').slick('slickPause');
        setTimeout(function(){
          $('.product-slider-col-2').slick('slickNext');
        }, 2000);
      });

      $('.product-slider-col-2').on('afterChange', function(){
        setTimeout(function(){
        $('.product-slider-col-3').slick('slickNext');
      }, 2000);
      });

      $('.product-slider-col-3').on('afterChange', function(){
        setTimeout(function(){
        $('.product-slider-col-1').slick('slickNext');
      }, 2000);
      });

      $('.ddc-product-image-slider .slider-inner').slick({
        autoplaySpeed: 7000,
        adaptiveHeight: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        prevArrow:"<img class='a-left control-c prev slick-prev' src='/wp-content/themes/minotti/dist/images/left_arrow.png'>",
        nextArrow:"<img class='a-right control-c next slick-next' src='/wp-content/themes/minotti/dist/images/right_arrow.png'>"
      }).on('setPosition', function (event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
      });

      $('.portfolio-slider .slider-inner').slick({
          autoplaySpeed: 7000,
          infinite: true,
          speed: 500,
          fade: true,
          cssEase: 'linear',
          prevArrow:"<img class='a-left control-c prev slick-prev' src='/wp-content/themes/minotti/dist/images/left_arrow.png'>",
          nextArrow:"<img class='a-right control-c next slick-next' src='/wp-content/themes/minotti/dist/images/right_arrow.png'>"
        });
    });

    $('.ddc-product-specs .ddc-spec-label').click(function(){
        $(this).parent().find('.ddc-spec-data').slideToggle();
        $(this).find('.a_status').toggleClass('open');
    });

    $('.reg-btn').click(function(){
      $('.sale-register-login').addClass('visible');
      $('.sale-existing-login').addClass('hidden');
    });

    $('.ddc-account-login').click(function(){
        $('.ddc-login-modal').fadeToggle('fast');
        $('.modal-shade').fadeToggle('fast');
    });

    $('.inquire-btn').click(function(){
      $('.ddc-inquire-modal').fadeToggle('fast');
      $('.modal-shade').fadeToggle('fast');
  });

    $('.modal-shade,.ddc-guest').click(function(){
      $('.ddc-modal').fadeOut('fast');
      $('.modal-shade').fadeOut('fast');
    });

    //Scroll to top button
    //Set a variable for our button element.
const scrollToTopButton = document.getElementById('js-top');

const scrollFunc = () => {
  // Get the current scroll value
  let y = window.scrollY;

  // If the scroll value is greater than the window height, let's add a class to the scroll-to-top button to show it!
  if (y > 300) {
    scrollToTopButton.className = "top-link show";
  } else {
    scrollToTopButton.className = "top-link hide";
  }
};

// When the button is clicked, run our ScrolltoTop function above!
scrollToTopButton.onclick = function(e) {
  e.preventDefault();
  scrollToTop();
}

window.addEventListener("scroll", scrollFunc);

const scrollToTop = () => {
  // Let's set a variable for the number of pixels we are from the top of the document.
  const c = document.documentElement.scrollTop || document.body.scrollTop;

  // If that number is greater than 0, we'll scroll back to 0, or the top of the document.
  // We'll also animate that scroll with requestAnimationFrame:
  // https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
  if (c > 0) {
    window.requestAnimationFrame(scrollToTop);
    // ScrollTo takes an x and a y coordinate.
    // Increase the '10' value to get a smoother/slower scroll!
    window.scrollTo(0, c - c / 10);
  }
};

    // $(document).ready(function($) {
    //   $('.woocommerce-ordering select').select2(); // Add your target select field
    //   $('.ddc-ajax-filters select').select2();
    //   $('.woocommerce-form-register select').select2();
    //  });

      $("body").on('click', 'a.ddc-search-toggle,.ddc-search-close', function(e) {
        event.preventDefault();
        e.stopImmediatePropagation();
        $('.ddc-product-search').toggleClass('ddc-search-visible');
      });

      //Scroll to stores in footer
      $("body").on('click', 'li.mega-store-scroll a', function(e) {
        event.preventDefault();
        e.stopImmediatePropagation();
        $('html, body').animate({
            scrollTop: $("footer.content-info").offset().top -100
        }, 1000);
      });

      $("body").on('click', '.lower-footer h3', function(e) {
        if ($(window).width() < 801) {
          $(this).next().slideToggle();
        }
      });

      $(document).ready(function( $ ) {
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();

            if (scroll >= 200) {
              $("body").addClass("body-scrolled");
            } else {
              $("body").removeClass("body-scrolled");
            }
        });
      });

      $(function(){
        var lastScrollTop = 0, delta = 5;
        $(window).scroll(function(){
          var nowScrollTop = $(this).scrollTop();
          if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
            if (nowScrollTop > lastScrollTop) {
              // SCROLLING DOWN
              $("body").removeClass("scrolling-up");
            } else {
              // SCROLLING UP
              $("body").addClass("scrolling-up");
            }
            lastScrollTop = nowScrollTop;
          }
        });
      });

      $('.figure-with-caption,.centered-video,.home-feature--portrait,.designer-video-col').each(function () {
        var video = $(this).find('video');
        var plainVideo = video.get(0);/*DOM video object, unwrapped from jQuery*/
        var playBtn = $(this).find('.play-overlay');
  
        playBtn.click(function () {
            video.get(0).addEventListener('ended',myHandler,false);
            video.prop('controls',true); 
            plainVideo.play();
            playBtn.css('visibility', 'hidden');
  
            function myHandler() {
                playBtn.css('visibility', 'visible');
            }
        });
      });

      $(document).on('click', '.filter-inactive', function() {
        $('.filter-sidebar').addClass('filter-open');
        setTimeout(function(){ 
          $('.filter-sidebar').addClass('filter-visible');
          $('.toggle-filter').addClass('filter-active');
          $('.toggle-filter').removeClass('filter-inactive');
        }, 550);
      });
      
      $(document).on('click', '.filter-active', function() {
        $('.filter-sidebar').removeClass('filter-visible');
        setTimeout(function(){ 
          $('.filter-sidebar').removeClass('filter-visible');
          $('.filter-sidebar').removeClass('filter-open');
          $('.toggle-filter').addClass('filter-inactive');
          $('.toggle-filter').removeClass('filter-active');
        }, 550);
      });

      $(function() {
        $(".berocket_single_filter_widget").children().addClass("closed");

        $("#filter-toggle").on("click", function () {
          $(".berocket_single_filter_widget").children().toggleClass("closed");

          if ($("#filter-toggle").children("i").hasClass("fa-toggle-on")) {
            $("#filter-toggle").children("i").removeClass("fa-toggle-on").addClass("fa-toggle-off");
          } else {
            $("#filter-toggle").children("i").removeClass("fa-toggle-off").addClass("fa-toggle-on");
          }

        });
      });

      //switch out class on icons in filter sidebar
      var el = $('.filter-sidebar .fa');
      el.addClass('far');
      el.removeClass('fa');

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    if( $('.single-product') ){
      var prevPage = document.referrer;
      var refProdID = $('.ddc-product-data').data('product-id');
      $('a.ddc-back-btn').attr('href', prevPage + '#' + refProdID );
    }

    $('.ddc-ajax-filters .filter-toggle').click(function(){
      $('.filter-wrap').slideToggle();
    });

    $('.sale-modal-shade,.ddc-sale-modal').click(function(){
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
      Cookies.set('SALE', 'Sale Active',{
        expires: date
      });
        $('.ddc-sale-modal').fadeOut();
        $('.sale-modal-shade').fadeOut();

    });

    //Scroll to stores in footer
    $("body").on('click', '.sale-information a.btn', function(e) {
      event.preventDefault();
      e.stopImmediatePropagation();
      $('html, body').animate({
          scrollTop: $("#sale-signup").offset().top -100
      }, 1000);
      
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js